import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Infos } from './Infos'
import { IBasicPage } from './types'

export const BasicPage: FC<IBasicPage> = ({ seo, header, footer, content }) => (
  <Page seo={seo} header={header} footer={footer}>
    <Infos content={content} />
  </Page>
)
